// extracted by mini-css-extract-plugin
export var annualPlanCard = "SharedPlanStyles_annualPlanCard__IiBF-";
export var buildMyBoxWrapper = "SharedPlanStyles_buildMyBoxWrapper__F97p3";
export var contentBottomDisclaimer = "SharedPlanStyles_contentBottomDisclaimer__q-FGF";
export var planCardContainer = "SharedPlanStyles_planCardContainer__qNau-";
export var planSelectedLabel = "SharedPlanStyles_planSelectedLabel__Agker";
export var plansContent = "SharedPlanStyles_plansContent__0mtiU";
export var plansContentBadge = "SharedPlanStyles_plansContentBadge__v7eOO";
export var plansContentPrice = "SharedPlanStyles_plansContentPrice__2-YBM";
export var plansLegalText = "SharedPlanStyles_plansLegalText__OYypZ";
export var plansLineDivider = "SharedPlanStyles_plansLineDivider__4-MBt";
export var plansOptionsSelected = "SharedPlanStyles_plansOptionsSelected__2-jFA";
export var plansOptionsWrapper = "SharedPlanStyles_plansOptionsWrapper__9ZcfD";
export var plansPriceContainer = "SharedPlanStyles_plansPriceContainer__nC45l";
export var plansTitle = "SharedPlanStyles_plansTitle__6weon";
export var seasonalPlanCard = "SharedPlanStyles_seasonalPlanCard__HXEsd";